
import XNumber from 'vux/src/components/x-number/index.vue'


export default {
components: {
XNumber
},
data() {
return {
vm: 0
}
},
methods: {
cIt(value) {
console.log(value)
if (this.vm > 3) {
console.log(this.vm)
this.vm = 3
console.log(this.vm)
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Test2.vue